import { createSlice } from '@reduxjs/toolkit';
import { isBrowser } from 'ws-scripts/modules/environment';
import { viewportWidthSizes } from '../../global-constants';

const initialState = {
	layout: 'list',
	isSmallScreen: false
};

const layoutSlice = createSlice({
	name: 'layout',
	initialState,
	reducers: {
		setLayout(state, action) {
			return {
				...state,
				...action.payload
			};
		}
	}
});
const { SM_VIEWPORT_WIDTH_SIZE } = viewportWidthSizes;
export const { setLayout } = layoutSlice.actions;

export const getIsSmallScreen = (viewportWidth) => {
	return viewportWidth < SM_VIEWPORT_WIDTH_SIZE;
};

export const getSpotIconSize = (deviceType) => {
	const screen =
		deviceType === 'DESKTOP' && isBrowser && window.screen?.width > 1200
			? 'HIRES'
			: deviceType;
	return (
		{
			HIRES: '104',
			DESKTOP: '96',
			MOBILE: '80'
		}[screen] ?? '96'
	);
};

// ADD THESE SELECTORS HERE:
export const selectIsGridLayout = (state) => {
	return state.layout.layout === 'grid' && !state.layout.isSmallScreen;
};

export const selectIsListLayout = (state) => {
	return state.layout.layout === 'list' && !state.layout.isSmallScreen;
};

export const selectIsTabbedLayout = (state) => {
	return state.layout.isSmallScreen || selectIsGridLayout(state);
};

export default layoutSlice.reducer;
